import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { CreateEmailLanding, StartNewImg, TemplatesImg } from '@frontend/create-email-landing';
import { useTranslation } from '@frontend/i18n';
import { BulkEmailPrefixes } from '@frontend/tracking-prefixes';
import { useBulkMessageEditorContext } from '../bulk-message-editor.context';
import { useBulkNavigator } from '../hooks/use-bulk-navigator';

export const BulkEmailLanding = () => {
  const { t } = useTranslation('bulk-messaging');
  const navigateTo = useBulkNavigator(CampaignType.EMAIL);
  const { templateJson } = useBulkMessageEditorContext();

  const cards = [
    {
      buttonText: t('New Campaign'),
      description: t('Start from scratch with a new email campaign'),
      imgSrc: StartNewImg,
      onClick: () => navigateTo.composer({ startFresh: !!templateJson }),
      title: t('Start New'),
      trackingId: `${BulkEmailPrefixes.Editor}-new-campaign-new-btn`,
    },
    {
      buttonText: t('Use Template'),
      description: t('Start with a template for your email marketing campaign'),
      imgSrc: TemplatesImg,
      onClick: navigateTo.templates,
      title: t('Use a Template'),
      trackingId: `${BulkEmailPrefixes.Editor}-new-campaign-use-template-btn`,
    },
  ];

  return (
    <CreateEmailLanding
      cancelTrackingId={`${BulkEmailPrefixes.Editor}-new-campaign-cancel-btn`}
      cards={cards}
      onCancel={navigateTo.editor}
    />
  );
};
